// @flow

import * as React from "react";

import s from "./DatePicker.scss";

import Calendar from "../Calendar/Calendar.jsx";
import calendar from '../images/calendar.svg';

type Props = {
  label: string,
  name: string,
  date: string,
  onChange: (e: SyntheticEvent<any>) => void,
  disabled: boolean
};

export const DatePicker = (props: Props) => {
  const { label, name, date, disabled, onChange, ...otherprops } = props;

  return (
    <div className={s.wrapper}>
      <label className={s.label}>
        {label}
        <br/>
        <Calendar
          className={s.input}
          name={name}
          value={date}
          onChange={e => onChange(e)}
          disabled={disabled}
          label=""
          {...otherprops}
        />
      </label>
      <img src={calendar} className={s.icon} alt="calendar"/>
    </div>
  );
};

export default DatePicker;
